import { createGlobalStyle } from 'styled-components/macro'

import { ScreenSize, mq } from './mq'
import { theme } from './theme'
import BackgroundImage from 'assets/backgrund.png'

export const GlobalStyle = createGlobalStyle`
:root {
  --container-width: ${ScreenSize.LG / 10}rem;
  --container-spacing: 2rem;
  --text-color: ${theme.colors.text};
  --background: ${theme.colors.background};
  --font-base: ${theme.fonts.ltr.base};
  --font-headings: ${theme.fonts.ltr.headings};
}

${mq.medium} {
  :root {
    --container-spacing: 4rem;
  }
}

html {
  height: 100%;
  font-size: 62.5%;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: var(--font-base),
    sans-serif;
  min-height: 100%;
  width: 100%;
  font-size: 1.6rem;
  font-smooth: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: auto;
  -webkit-tap-highlight-color: transparent;
  color: var(--text-color);
  background: var(--background) url("${BackgroundImage}") center top repeat;
}

[dir="rtl"] {
  --font-base: ${theme.fonts.rtl.base};
  --font-headings: ${theme.fonts.rtl.headings};
}

*, *::before, *::after {
  box-sizing: border-box;
}

html.locked {
  overflow: hidden;
}

#root {
  display: contents;

  > * {
    flex-shrink: 0;
  }
}

a {
  color: inherit;
}
`
